import API from "../helpers/Api";

const querystring = require("querystring");

export const aceitaPreFatura = (fatura, empenho) => {
  return API.post(`rest/aceitaPreFatura?fatura=${fatura}&empenho=${empenho}`);
};

export const contestaPreFatura = (fatura, questionamento) => {
  return API.post(
    `rest/contestaPreFatura?fatura=${fatura}&questionamento=${questionamento}`
  );
};

export const getContestacoes = fatura => {
  return API.get(`rest/contestaPreFatura?fatura=${fatura}`);
};

export const getFatura = params => {
  return API.get(`rest/relFatura`, {
    params: params,
    paramsSerializer: function(params) {
      return querystring.stringify(params);
    }
  });
};

export const getFaturaItens = params => {
  return API.get(`rest/relFaturaItem`, {
    params: params,
    paramsSerializer: function(params) {
      return querystring.stringify(params);
    }
  });
};
